// frontend/src/utils/analytics.js

export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

// Check if GA is loaded and properly configured
export const isGALoaded = () => {
  return typeof window !== 'undefined' && 
         window.gtag && 
         GA_TRACKING_ID && 
         GA_TRACKING_ID !== 'undefined' &&
         !GA_TRACKING_ID.includes('%REACT_APP_GA_TRACKING_ID%');
};

// Track page views
export const trackPageView = (path, title) => {
  if (isGALoaded()) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: path,
      page_title: title,
    });
    console.log('📊 GA: Page view tracked -', title, path);
  } else {
    console.log('❌ GA: Not loaded, skipping page view tracking for', path);
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (isGALoaded()) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
    console.log('📊 GA: Event tracked -', action, category, label);
  } else {
    console.log('❌ GA: Not loaded, skipping event tracking for', action);
  }
};

// Common tracking functions for CircledIn
export const trackClick = (elementName, location) => {
  trackEvent('click', 'engagement', `${elementName}_${location}`);
};

export const trackFormSubmit = (formName) => {
  trackEvent('form_submit', 'engagement', formName);
};

export const trackNavigation = (destination) => {
  trackEvent('navigation', 'user_flow', destination);
};

export const trackCircleJoin = (circleId, planType) => {
  trackEvent('circle_join', 'conversion', `circle_${circleId}_${planType}`, 1);
};

export const trackPayment = (amount, paymentType) => {
  trackEvent('purchase', 'conversion', paymentType, amount);
};

export const trackAuth = (action) => {
  trackEvent('auth_action', 'user_engagement', action);
};

export const trackCarrierSelection = (carrier) => {
  trackEvent('carrier_selected', 'user_preference', carrier);
};

export const trackPlanSelection = (planName, carrier) => {
  trackEvent('plan_selected', 'user_preference', `${carrier}_${planName}`);
};

export const trackReferral = (action, code) => {
  trackEvent('referral_action', 'growth', `${action}_${code}`);
};

// Debug function to test GA setup
export const testGA = () => {
  console.log('=== GA Debug Info ===');
  console.log('GA_TRACKING_ID:', GA_TRACKING_ID);
  console.log('window.gtag exists:', typeof window.gtag);
  console.log('window.dataLayer exists:', Array.isArray(window.dataLayer));
  console.log('isGALoaded():', isGALoaded());
  
  if (isGALoaded()) {
    trackEvent('test_event', 'debug', 'manual_test', 1);
    console.log('✅ Test event sent to GA');
    return true;
  } else {
    console.log('❌ GA not properly loaded');
    return false;
  }
};

// Get GA status for debugging
export const getGAStatus = () => {
  return {
    trackingId: GA_TRACKING_ID,
    gtagLoaded: typeof window.gtag !== 'undefined',
    dataLayerExists: typeof window.dataLayer !== 'undefined',
    isLoaded: isGALoaded()
  };
};